import React from 'react';
import { Form, Card, Alert, Row, Col, ButtonGroup, Button, Badge } from 'react-bootstrap';
import FileUploadDemo from './shared/FileUploadDemo';
import MapSelector from './shared/MapSelector';

const RiberaStep4 = ({ formData, onChange }) => {
    const handleFileChange = (name, file) => {
        onChange({ ...formData, [name]: file });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        onChange({ ...formData, [name]: value });
    };

    const handleLocationSelect = (location) => {
        onChange({ ...formData, ubicacionGeografica: location });
    };

    const handleAddImage = (fieldName) => {
        const currentImages = formData[fieldName] || [];
        const updatedImages = Array.isArray(currentImages) ? [...currentImages, null] : [currentImages, null];
        onChange({ ...formData, [fieldName]: updatedImages });
    };

    const handleImageChange = (fieldName, index, file) => {
        const currentImages = formData[fieldName] || [];
        const updatedImages = Array.isArray(currentImages) ? [...currentImages] : [currentImages];
        updatedImages[index] = file;
        onChange({ ...formData, [fieldName]: updatedImages });
    };

    const handleRemoveImage = (fieldName, index) => {
        const currentImages = formData[fieldName] || [];
        const updatedImages = Array.isArray(currentImages) ? [...currentImages] : [currentImages];
        updatedImages.splice(index, 1);
        onChange({ ...formData, [fieldName]: updatedImages.length > 0 ? updatedImages : null });
    };



    return (
        <Card className="shadow-sm">
            <Card.Header className="bg-primary text-white">
                <h5 className="mb-0">Paso 4: Información de Campo e Imágenes</h5>
            </Card.Header>
            <Card.Body>
                <Alert variant="info" className="mb-4">
                    <strong>Documentación Fotográfica y Datos de Campo:</strong> Adjunte imágenes del lugar
                    e ingrese las mediciones realizadas en campo.
                </Alert>

                <h6 className="text-primary mb-3">Imágenes del Cauce y Barranca</h6>

                <div className="mb-4">
                    <Form.Label className="fw-bold">Fotografías del Cauce</Form.Label>
                    {Array.isArray(formData.imagenesCauce) && formData.imagenesCauce.length > 0 ? (
                        formData.imagenesCauce.map((img, index) => (
                            <div key={index} className="mb-3 p-3 border rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span className="text-muted">Imagen {index + 1}</span>
                                    <Button
                                        variant="outline-danger"
                                        size="sm"
                                        onClick={() => handleRemoveImage('imagenesCauce', index)}
                                    >
                                        ✕ Eliminar
                                    </Button>
                                </div>
                                <Form.Control
                                    type="file"
                                    accept=".jpg,.jpeg,.png"
                                    onChange={(e) => handleImageChange('imagenesCauce', index, e.target.files[0])}
                                    style={{ maxWidth: '400px' }}
                                />
                                {img && (
                                    <Badge bg="success" className="mt-2">
                                        📄 {img.name}
                                    </Badge>
                                )}
                                <Form.Text className="d-block text-muted mt-1">
                                    Formatos aceptados: JPG, PNG
                                </Form.Text>
                            </div>
                        ))
                    ) : (
                        <div className="text-muted p-3 border rounded">
                            No hay imágenes agregadas aún
                        </div>
                    )}
                    <Button
                        variant="success"
                        size="sm"
                        onClick={() => handleAddImage('imagenesCauce')}
                        className="mt-2"
                    >
                        + Agregar Fotografía del Cauce
                    </Button>
                </div>

                <div className="mb-4">
                    <Form.Label className="fw-bold">Fotografías de la Barranca</Form.Label>
                    {Array.isArray(formData.imagenesBarranca) && formData.imagenesBarranca.length > 0 ? (
                        formData.imagenesBarranca.map((img, index) => (
                            <div key={index} className="mb-3 p-3 border rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span className="text-muted">Imagen {index + 1}</span>
                                    <Button
                                        variant="outline-danger"
                                        size="sm"
                                        onClick={() => handleRemoveImage('imagenesBarranca', index)}
                                    >
                                        ✕ Eliminar
                                    </Button>
                                </div>
                                <Form.Control
                                    type="file"
                                    accept=".jpg,.jpeg,.png"
                                    onChange={(e) => handleImageChange('imagenesBarranca', index, e.target.files[0])}
                                    style={{ maxWidth: '400px' }}
                                />
                                {img && (
                                    <Badge bg="success" className="mt-2">
                                        📄 {img.name}
                                    </Badge>
                                )}
                                <Form.Text className="d-block text-muted mt-1">
                                    Formatos aceptados: JPG, PNG
                                </Form.Text>
                            </div>
                        ))
                    ) : (
                        <div className="text-muted p-3 border rounded">
                            No hay imágenes agregadas aún
                        </div>
                    )}
                    <Button
                        variant="success"
                        size="sm"
                        onClick={() => handleAddImage('imagenesBarranca')}
                        className="mt-2"
                    >
                        + Agregar Fotografía de la Barranca
                    </Button>
                </div>

                <hr className="my-4" />

                <h6 className="text-primary mb-3">Mediciones de Campo</h6>

                <Row>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Altura de Barranca (metros)</Form.Label>
                            <Form.Control
                                type="number"
                                name="alturaBarranca"
                                value={formData.alturaBarranca || ''}
                                onChange={handleChange}
                                placeholder="Ej: 2.5"
                                step="0.1"
                                min="0"
                            />
                        </Form.Group>
                    </Col>

                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Distancia Barranca - Mensura (metros)</Form.Label>
                            <Form.Control
                                type="number"
                                name="distanciaBarrancaMensura"
                                value={formData.distanciaBarrancaMensura || ''}
                                onChange={handleChange}
                                placeholder="Ej: 15.3"
                                step="0.1"
                                min="0"
                            />
                        </Form.Group>
                    </Col>
                </Row>

                <hr className="my-4" />

                <h6 className="text-primary mb-3">Ubicación Geográfica</h6>

                <Alert variant="secondary" className="mb-3">
                    Indique la ubicación del trabajo en el mapa:
                </Alert>

                <MapSelector
                    onLocationSelect={handleLocationSelect}
                    selectedLocation={formData.ubicacionGeografica}
                />
            </Card.Body>
        </Card>
    );
};

export default RiberaStep4;
